<template>
    <BaseDialog
        v-model:visible="visible"
        :header="`Edit Permissions for ${member?.name}`"
        :closable="true"
        :modal="true"
        class="w-[30rem]"
        :okLabel="'Save'"
        :saveAction="onSave"
    >
        <template #content>
            <div>
                <Accordion v-model:value="activeTab" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
                    <AccordionPanel
                        v-for="(permissions, category, index) in groupedPermissions"
                        :key="category"
                        :value="index"
                    >
                        <AccordionHeader>
                            {{ category }}
                            <Badge :value="permissions.length" class="ml-auto mr-2" />
                        </AccordionHeader>
                        <AccordionContent>
                            <div class="flex flex-col gap-4">
                                <div
                                    v-for="permission in permissions"
                                    :key="permission"
                                    class="flex items-center justify-between"
                                >
                                    <Tag
                                        :value="getPermissionsLabel(permission)"
                                        :icon="getPermissionsIcon(permission)"
                                        :severity="getPermissionsSeverity(permission)"
                                        v-tooltip.top="getPermissionsDescription(permission)"
                                    />
                                    <ToggleSwitch
                                        :model-value="member.permissions.includes(permission)"
                                        @update:model-value="() => togglePermission(permission)"
                                    />
                                </div>
                            </div>
                        </AccordionContent>
                    </AccordionPanel>
                </Accordion>
            </div>
        </template>
    </BaseDialog>
</template>

<script setup>
import { ref, defineModel, watch, defineProps, defineEmits } from "vue";
import BaseDialog from "@/shared/components/BaseDialog.vue";
import ToggleSwitch from "primevue/toggleswitch";
import Tag from "primevue/tag";
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import Badge from "primevue/badge";

const visible = defineModel("visible");

const props = defineProps({
    member: Object,
    groupedPermissions: Object,
    getPermissionsLabel: Function,
    getPermissionsDescription: Function,
    getPermissionsSeverity: Function,
    getPermissionsIcon: Function,
});

const emit = defineEmits(["save", "toggle-permission"]);

const activeTab = ref(0);

const onSave = () => emit("save");
const togglePermission = (permission) => emit("toggle-permission", permission);
</script>
